export default __webpack_public_path__ + "static/media/virtual_services_button_fr.3e95db17.png";